const toDegrees = function (angle) {
  return angle * (180 / Math.PI)
}

const toRadians = function (angle) {
  return angle * (Math.PI / 180)
}

class Point {
  constructor (x, y) {
    this.x = x
    this.y = y
  }

  round () {
    this.x = Math.round(this.x)
    this.y = Math.round(this.y)
  }

  get length () {
    return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2))
  }

  get angle () {
    return toDegrees(Math.atan2(this.y, this.x))
  }

  direction (p) {
    return new Point(p.x - this.x, p.y - this.y)
  }

  component (v) {
    return (this.x * v.x + this.y * v.y) / v.length
  }

  static distance(p, q) {
    return Math.hypot(p.x - q.x, p.y - q.y)
  }
}

const opposite = function (p) {
  return new Point(-p.x, -p.y)
}

const rotateOrigin = function (angle) {
  return function (p) {
    return new Point(
      p.x * Math.cos(toRadians(angle)) - p.y * Math.sin(toRadians(angle)),
      p.x * Math.sin(toRadians(angle)) + p.y * Math.cos(toRadians(angle))
    )
  }
}

const scaleOrigin = function (scaleFactor) {
  return function (p) {
    return new Point(scaleFactor * p.x, scaleFactor * p.y);
  }
}

const scaleDirOrigin = function (scaleFactor, v) {
  return function (p) {
    p = rotateOrigin(-v.angle)(p)
    let q = new Point(scaleFactor*p.x, p.y)
    q = rotateOrigin(v.angle)(q)
    return q
  }
}

const translate = function (vector) {
  return function (point) {
    return new Point(point.x + vector.x, point.y + vector.y)
  }
}

const moveTransformOrigin = function (transformation, point) {
  return function (p) {
    return translate(point)(
      transformation(translate(opposite(point))(p))
    )
  }
}

const rotate = function (angle, center = new Point(0, 0)) {
  return moveTransformOrigin(rotateOrigin(angle), center)
}

const scale = function (scaleFactor, center = new Point(0, 0)) {
  return moveTransformOrigin(scaleOrigin(scaleFactor), center)
}

const scaleDir = function (scaleFactor, v, center = new Point(0, 0)) {
  return moveTransformOrigin(scaleDirOrigin(scaleFactor, v), center)
}

export {Point, translate, rotate, scaleDir}
